import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { AnswerSubCategoryDetail } from "@/schema/console/checking-assessments/AnswerSubCategoryDetail";
import { useId } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface EvaluationRadioGroupProps {
  evaluationIndex: number;
  contentIndex: number;
}

function EvaluationRadioGroup({
  evaluationIndex,
  contentIndex,
}: EvaluationRadioGroupProps) {
  const id = useId();
  const { control } = useFormContext<AnswerSubCategoryDetail>();

  const {
    field: { value: evaluationRate, onChange: onEvaluationRateChange },
  } = useController({
    control,
    name: `answer_contents.${contentIndex}.answer_evaluations.${evaluationIndex}.evaluation_rate`,
  });
  const { t } = useTranslation();
  return (
    <RadioGroup
      className="mt-5 inline-flex gap-12"
      value={evaluationRate.toString()}
      onValueChange={(value) => {
        onEvaluationRateChange(parseInt(value));
      }}
    >
      <div className=" flex flex-row space-x-4">
        <label
          htmlFor={`${id} 0`}
          className="cursor-pointer flex flex-row space-x-2"
        >
          <RadioGroupItem id={`${id} 0`} value={"0"} />
          <span>{t("ineligible")}</span>
        </label>
        <div className=" flex flex-row border-l border-l-cool-gray-300 pl-4 space-x-4">
          <label
            htmlFor={`${id} 1`}
            className="cursor-pointer flex flex-row space-x-2"
          >
            <RadioGroupItem id={`${id} 1`} value={"1"} />
            <span>0%</span>
          </label>
          <label
            htmlFor={`${id} 2`}
            className="cursor-pointer flex flex-row space-x-2"
          >
            <RadioGroupItem id={`${id} 2`} value={"2"} />
            <span>50%</span>
          </label>
          <label
            htmlFor={`${id} 3`}
            className="cursor-pointer flex flex-row space-x-2"
          >
            <RadioGroupItem id={`${id} 3`} value={"3"} />
            <span>100%</span>
          </label>
        </div>
      </div>
    </RadioGroup>
  );
}

export default EvaluationRadioGroup;
